import PageCommon from "../PageCommon.js";
import ServiceManager from '../../3x1010/services/ServiceManager.js';

export default class PageChristmasSpirits2024ThankYou extends PageCommon {
    constructor() {
        super();
    }
    init($data) {
        super.init($data);
        console.log("PageChristmasSpirits2024ThankYou");
        this.showPreloader(false);
        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
        }
        catch {
            console.error()
        }
    }
}